/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Family_Xml_FeedInputs */

const cs_portals_family_xml_feed = /** @type {(inputs: Portals_Family_Xml_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML feed`)
};

const en_portals_family_xml_feed = /** @type {(inputs: Portals_Family_Xml_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML feed`)
};

/**
* | output |
* | --- |
* | "XML feed" |
*
* @param {Portals_Family_Xml_FeedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_family_xml_feed = /** @type {((inputs?: Portals_Family_Xml_FeedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Family_Xml_FeedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_family_xml_feed(inputs)
	return cs_portals_family_xml_feed(inputs)
});